const getBanners = (action) => action.entities.banners;

export default function bannersReducer(state = {}, action) {
  switch (action.type) {
    case "BANNERS_FETCHED":
      // Replace (not merge) so banners the backend no longer returns disappear
      return { ...getBanners(action) };
    default:
      return state;
  }
}
